import api from "@/apis/RefundAPI";
import Crud from "./crud-base";
import httpClient from "@/apis/base/axios-httpclient";
import stateOverride from "@/stores/refund/module-refund-state";
import mutationsOverride from "@/stores/refund/module-refund-mutations";
import actionsOverride from "@/stores/refund/module-refund-actions";
import gettersOverride from "@/stores/refund/module-refund-getters";
var crud = new Crud("refund", api);

const state = {
  ...crud.state,
  ...stateOverride,
  _config: {
    field: {
      key: "code",
      code: "name",
      name: "name",
    },
  },
  datas: [],
  // Tổng số tiền hiển thị
  totalOrderAmount: 0,
  totalAmount: 0,
  totalFeeAmount: 0,
};
const getters = {
  ...crud.getters,
  ...gettersOverride,
};
const actions = {
  ...crud.actions,
  ...actionsOverride,
  /**
   *  Load danh sách
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit("updateLoading", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoading", false);
    }

    if (res && !payload.notUpdateItem) {
      context.commit("setItems", { result: res, payload: payload });
    } else {
      context.commit("setDatas", { result: res, payload: payload });
    }
    context.commit("SET_TRANSACTIONS", res);
    context.commit("TOTAL_AMOUNT");
    return res;
  },
};
const mutations = {
  ...crud.mutations,
  ...mutationsOverride,
  setDatas(state, data) {
    if (data.result) {
      if (data.result.length > 0) {
        state.datas.removeAll();
        state.datas = data.result;
        //state.dataTotal = resultValue;
      }
    }
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
